// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components

// ----------------------------------------------------------------------

// const icon = (name) => (
//   <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
// );

const icon = (name) => (
  <img alt={name} src={`/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  user: icon("ic_user"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
  coupon: icon("ic_coupon"),
  notification: icon("ic_notification"),
  profile: icon("ic_profile"),
  videohub: icon("ic_pages"),
  settings: icon("ic_settings"),
  tripHour: icon("ic_trip_hr"),
  blogs: icon("ic_blogs"),
  vehicle: icon("ic_vehicle"),
  reports: icon("ic_reports"),
  photo: icon("ic_photo"),
};

const navConfig = [
  {
    subheader: "Contents",
    items: [
      {
        title: "Banners",
        path: PATH_DASHBOARD.banner.root,
        icon: ICONS.blogs,
        children: [
          { title: "Banners list", path: PATH_DASHBOARD.banner.list },
          { title: "Create new banner", path: PATH_DASHBOARD.banner.add },
        ],
      },

      {
        title: "News",
        path: PATH_DASHBOARD.news.root,
        icon: ICONS.blogs,
        children: [
          { title: "News list", path: PATH_DASHBOARD.news.list },
          { title: "Categories", path: PATH_DASHBOARD.news.categories },
          { title: "Create new news", path: PATH_DASHBOARD.news.add },
        ],
      },

      {
        title: "Features",
        path: PATH_DASHBOARD.feature.root,
        icon: ICONS.blogs,
        children: [
          { title: "Features list", path: PATH_DASHBOARD.feature.list },
          { title: "Categories", path: PATH_DASHBOARD.feature.categories },
          { title: "Create new feature", path: PATH_DASHBOARD.feature.add },
        ],
      },

      {
        title: "Photos",
        path: PATH_DASHBOARD.photo.root,
        icon: ICONS.photo,
        children: [
          { title: "photos list", path: PATH_DASHBOARD.photo.list },
          { title: "Categories", path: PATH_DASHBOARD.photo.categories },
          { title: "Create Photo", path: PATH_DASHBOARD.photo.add },
        ],
      },
      {
        title: "VideoHub",
        path: PATH_DASHBOARD.videohub.root,
        icon: ICONS.videohub,
        children: [
          { title: "videohub list", path: PATH_DASHBOARD.videohub.list },
          { title: "Categories", path: PATH_DASHBOARD.videohub.categories },
          { title: "Create VideHub", path: PATH_DASHBOARD.videohub.add },
        ],
      },
    ],
  },
];

export default navConfig;
